import palette from '@lib/core/src/theme/palette';
import CloseIcon from '@mui/icons-material/Close';
import { alpha, Stack } from '@mui/material';

import { Title } from './TaskDismissNotification';

export const TaskTitleEditNotification = ({ onClose }: { onClose: () => void }) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="center"
    flex={1}
    padding={'8px 0px'}
    gap={'8px'}
  >
    <Title>The task has been created successfully.</Title>

    <CloseIcon
      onClick={onClose}
      sx={{ cursor: 'pointer', color: alpha(palette.white, 0.7), width: '18px' }}
    />
  </Stack>
);
